export { default as RestaurantNewDishesPopup } from './RestaurantNewDishesPopup'
